import {defineStore} from 'pinia';
import {contacts} from "@js/company_details.ts";

export const useThemeStore = defineStore('themeStore', {
    state: () => ({
        footer_with_map: true,
        body_overflow_hidden: true,
        toasts: [],
    }),
    actions: {
        turnOffMap() {
            this.footer_with_map = false
        },
        turnOnMap() {
            this.footer_with_map = true
        },
        resetMap() {
            this.footer_with_map = true
        },
        setBodyOverflow(hidden) {
            this.body_overflow_hidden = hidden
            document.body.style.overflow = this.body_overflow_hidden ? 'hidden' : '';
        },
        addToast(message, type, linkData = null, timeout = 3000) {
            const id = Date.now() + Math.random().toString(36).substring(2, 9);
            this.toasts.push({id, message, type, linkData})

            let vm = this
            if (this.toasts.length >= 3) {
                this.removeToast(this.toasts[0].id);
            }

            setTimeout(() => {
                vm.removeToast(id)
            }, timeout)
        },
        removeToast(id) {
            this.toasts = this.toasts.filter(toast => toast.id !== id)
        },
        insertOrganizationSchemaMarkup() {
            if (typeof window !== "undefined") {
                const scriptId = "schema-organization-jsonld"
                let script = document.getElementById(scriptId)

                if (script) {
                    script.remove()
                }

                script = document.createElement("script")
                script.id = scriptId
                script.type = "application/ld+json"
                script.textContent = JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    "name": "ООО «Мода Керамикс Рус»",
                    "url": "https://moda-ceramics.store/",
                    "logo": "https://moda-ceramics.store/assets/logo/logo_square.svg",
                    "description": "Компания ООО «Мода Керамикс Рус» предоставляет широкий выбор керамической и керамогранитной плитки: мозаика, облицовка, фасады. Выгодные цены, оперативная доставка по Москве и московской области.",
                    "contactPoint": {
                        "@type": "ContactPoint",
                        "telephone": `+${contacts.first_phone}`,
                        "contactType": "Customer Service",
                        "areaServed": "RU",
                        "availableLanguage": "Russian"
                    },
                    "sameAs": [
                        contacts.whatsapp,
                        contacts.telegram,
                        contacts.yandex_map_link
                    ],
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "шоссе Алтуфьевское, дом 44, помещение 19",
                        "addressLocality": "Москва",
                        "addressRegion": "Москва",
                        "postalCode": "127566",
                        "addressCountry": "RU"
                    },
                })

                document.head.appendChild(script);
            }
        },

        insertLocalBusinessSchemaMarkup() {
            if (typeof window !== "undefined") {
                const scriptId = "schema-local-business-jsonld"
                let script = document.getElementById(scriptId)

                if (script) {
                    script.remove()
                }

                script = document.createElement("script")
                script.id = scriptId
                script.type = "application/ld+json"
                script.textContent = JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "LocalBusiness",
                    "name": "ООО «Мода Керамикс Рус»",
                    "url": "https://moda-ceramics.store/",
                    "logo": "https://moda-ceramics.store/assets/logo/logo-rounded-full.png",
                    "description": "Компания ООО «Мода Керамикс Рус» предоставляет широкий выбор керамической плитки и керамогранита для интерьеров и фасадов.",
                    "telephone": `+${contacts.first_phone}`,
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "шоссе Алтуфьевское, дом 44, помещение 19",
                        "addressLocality": "Москва",
                        "addressRegion": "Москва",
                        "postalCode": "127566",
                        "addressCountry": "RU"
                    },
                    "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 55.874500,
                        "longitude": 37.589480
                    },
                    "openingHours": "Mo-Su 09:00-20:00",
                    "openingHoursSpecification": {
                        "@type": "OpeningHoursSpecification",
                        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
                        "opens": "09:00",
                        "closes": "20:00"
                    },
                    "sameAs": [
                        contacts.whatsapp,
                        contacts.telegram,
                        contacts.yandex_map_link
                    ],
                    "priceRange": "$$"
                })

                document.head.appendChild(script);
            }
        },
        insertNavigationSchemaMarkup(menuItems) {
            if (typeof window !== "undefined") {
                const scriptId = "schema-navigation-jsonld"
                let script = document.getElementById(scriptId)

                if (script) {
                    script.remove()
                }

                script = document.createElement("script")
                script.id = scriptId
                script.type = "application/ld+json"

                function buildUrl(item) {
                    if (!item.route_name || !item.route_params) return null

                    const category = item.route_params.category_title
                    const query = item.route_params.query

                    let url = `https://moda-ceramics.store/catalog/${category}`

                    if (query && typeof query === 'object') {
                        const queryParams = new URLSearchParams()

                        Object.entries(query).forEach(([key, values]) => {
                            if (Array.isArray(values)) {
                                values.forEach(v => queryParams.append(`${key}[]`, v))
                            }
                        })

                        url += `?${queryParams.toString()}`
                    }

                    return url
                }

                function convertToJSONLD(items) {
                    return Object.values(items).map(item => {
                        const element = {
                            "@type": "SiteNavigationElement",
                            "name": item.title
                        }

                        const url = buildUrl(item)
                        if (url) {
                            element.url = url
                        }

                        if (item.sub_menu) {
                            // Если sub_menu — объект, а не массив
                            const submenus = Object.values(item.sub_menu)
                            let hasParts = []

                            submenus.forEach(sub => {
                                if (Array.isArray(sub.sub_menu)) {
                                    hasParts = hasParts.concat(convertToJSONLD(sub.sub_menu))
                                } else {
                                    hasParts.push({
                                        "@type": "SiteNavigationElement",
                                        "name": sub.title
                                    })
                                }
                            })

                            if (hasParts.length) {
                                element.hasPart = hasParts
                            }
                        }

                        return element
                    })
                }

                script.textContent = JSON.stringify({
                    "@context": "http://schema.org",
                    "@type": "ItemList",
                    "name": "Main Navigation",
                    "itemListElement": convertToJSONLD(menuItems)
                })

                document.head.appendChild(script)
            }
        }
    }
});
